module.exports = __webpack_public_path__ + "img/img_detail2_mobile.91cabb50.png";